import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div`

    display: flex;
    align-items: center;
    justify-content:flex-start;
    width:100%;
    margin-bottom:4vh;
`;

interface Props{
    focus: boolean;
}
export const LinkEstilizado = styled.span<Props>`

    color: ${({ focus }) => (focus ? theme.colors.primary : theme.colors.dark)};

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }
    font-size: 14px;
    text-align:justify;
   

`;